export type RoundupStyle = 'lassos' | 'heart' | 'mini'

export const getRoundupStyle = (): RoundupStyle => 'heart'
